import { useCallback, useMemo, useState } from 'react'

import { useDebounce, useInfiniteScrollQuery } from 'hooks'

export const useSearchRelatedGroups = ({ groupId }) => {
  const [searchText, setSearchText] = useState('')
  const debouncedSearchText = useDebounce(searchText, 500)

  const memoArg = useMemo(
    () => ({
      groupId,
      keyword: debouncedSearchText,
    }),
    [groupId, debouncedSearchText]
  )

  const { loadMore, shouldLoadMore, combinedResults, latestQuery, isLoading } =
    useInfiniteScrollQuery({
      memoArg,
      queryName: 'getRelatedGroups',
      paginationKeyName: 'from',
      dataKey: 'groups',
    })

  const relatedGroups = useMemo(
    () => ({
      data: combinedResults,
      isLoading,
      meta: {
        isFullyLoaded: !shouldLoadMore,
      },
    }),
    [loadMore, shouldLoadMore, isLoading, combinedResults, latestQuery]
  )

  const isEmptyList = useMemo(
    () => relatedGroups?.data?.length === 0,
    [relatedGroups]
  )

  const onLoadMore = useCallback(
    () => loadMore(latestQuery?.data?.next_page_value),
    [latestQuery]
  )

  return {
    searchText,
    setSearchText,
    relatedGroups,
    isEmptyList,
    onLoadMore,
  }
}
